export const useAppCache = () => {
  const { locale } = useI18n()

  return useLazyFetch('/api/data', {
    key: `app-cache-${locale.value}`,
    server: true,
    default: () => ({ data: { data: {} } }),
    dedupe: 'defer',
    query: {
      lang: locale.value
    }
  })
}
